import { RefObject } from "react";
import { useTranslation } from "react-i18next";
import { ReactComponent as DownArrows } from "../../../assets/svg/chevrons-down.svg";
import { OptionTypeResponse, SideResponse } from "../../../codegen-api";
import { AssetResponse } from "../../../utils/asset";
import { IPositionMap } from "../../../hooks/wss/usePositionsWSS.types";
import MobileFooter from "../../MobileFooter";
import MobileTradingBottomBar from "../../TradingBottomBar/MobileTradingBottomBar";
import Transition from "../../shared/Transition";
import CurrentSpotSection from "../CurrentSpotSection";
import { ITableContentRow } from "../OptionsTable";
import { Padding } from "../style";
import OptionRow from "./OptionRow";
import { TapToScroll } from "./style";

interface IMobileOptionsChainContentProps {
  filteredRows: {
    lessThanCurrPriceRows: ITableContentRow[];
    moreThanCurrPriceRows: ITableContentRow[];
  };
  positionsMap: IPositionMap;
  onTrade: (orderType: OptionTypeResponse, exp: number, strike: string) => void;
  optionTypeFilter: OptionTypeResponse;
  side: SideResponse;
  asset: AssetResponse;
  currentIndexPrice?: string;
  bottomBarRef: RefObject<HTMLDivElement>;
  scrollableContainerRef: RefObject<HTMLDivElement>;
  isBottomBarShowing: boolean;
  onScrollToPortfolioTray: () => void;
}

function MobileOptionsChainContent({
  filteredRows,
  positionsMap,
  onTrade,
  optionTypeFilter,
  side,
  asset,
  currentIndexPrice,
  bottomBarRef,
  scrollableContainerRef,
  isBottomBarShowing,
  onScrollToPortfolioTray,
}: IMobileOptionsChainContentProps) {
  const { t } = useTranslation("app", {
    keyPrefix: "OptionsChain.MobileOptionsChain.MobileOptionsChain",
  });

  return (
    <Transition>
      <Padding style={{ paddingTop: 0 }}>
        {filteredRows.lessThanCurrPriceRows.map((v) => (
          <OptionRow
            highlighted={!!positionsMap[v.ticker.instrumentName]}
            onClick={() => {
              onTrade(optionTypeFilter, Number(v.expiry!), v.strike!);
            }}
            key={`${v.ticker.instrumentId}`}
            data={v}
            type={optionTypeFilter}
            side={side}
          />
        ))}
        <CurrentSpotSection
          asset={asset}
          price={Number(currentIndexPrice)}
          loading={!currentIndexPrice}
        />
        {filteredRows.moreThanCurrPriceRows.map((v) => (
          <OptionRow
            highlighted={v.ticker.position !== 0}
            onClick={() => {
              onTrade(optionTypeFilter, v.expiry, v.strike);
            }}
            key={v.ticker.instrumentId}
            data={v}
            type={optionTypeFilter}
            side={side}
          />
        ))}
        <MobileTradingBottomBar ref={bottomBarRef} />
      </Padding>
      {
        // Only show footer if content is scrollable
        (scrollableContainerRef.current?.scrollHeight || 0) >
          document.body.clientHeight && (
          <MobileFooter>
            <TapToScroll
              key={String(isBottomBarShowing)}
              onClick={onScrollToPortfolioTray}
              $reversed={isBottomBarShowing}
            >
              {!isBottomBarShowing
                ? t("tap_to_scroll_portfolio")
                : t("tap_to_scroll_top")}
              <DownArrows />
            </TapToScroll>
          </MobileFooter>
        )
      }
    </Transition>
  );
}

export default MobileOptionsChainContent;
